import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { PushNotificationService } from 'app/pwa-services/push-notification.service';
import { DynamicDialogRef } from 'primeng/dynamicdialog';
import { Capacitor } from '@capacitor/core';
import { Camera } from '@capacitor/camera';
import { PushNotifications } from '@capacitor/push-notifications';
import { Haptics } from '@capacitor/haptics';
import { StatusBar } from '@capacitor/status-bar';
import { CommonModule } from '@angular/common';
import { StepperModule } from 'primeng/stepper';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@Component({
    selector: 'device-permission-dialog',
    templateUrl: './device-permission-dialog.component.html',
    imports: [
        CommonModule,
        StepperModule,
        ButtonModule,
        TranslateModule,
        FormsModule,
        ReactiveFormsModule
    ]
})
export class DevicePermissionDialogComponent implements OnInit {
    @Output() permissionsGranted = new EventEmitter<boolean>();

    currentStep = 1; // Tracks the active step

    constructor(
        private pushNotificationService: PushNotificationService,
        public ref: DynamicDialogRef,
    ) { }

    ngOnInit() { }

    askPushPermission(nextStepCallback: (step: number) => void) {
        if (Capacitor.isNativePlatform()) {
            PushNotifications.requestPermissions().then((result) => {
                if (result.receive === 'granted') {
                    this.pushNotificationService.subscribeToNotifications();
                } else {
                    alert('Push notifications permission is required for receiving notifications.');
                }
            });
        } else {
            this.pushNotificationService.subscribeToNotifications()
        }

        nextStepCallback(2);

    }

    async askCameraPermission(nextStepCallback: (step: number) => void) {
        if (Capacitor.isNativePlatform()) {
            Camera.requestPermissions({ permissions: ['camera', 'photos'] });
            nextStepCallback(3);

        } else {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ video: true });
                // … hier könntest Du ggfs. gleich eine Vorschau anzeigen …
                // Schließe aber direkt wieder alle Tracks:
                stream.getTracks().forEach(track => track.stop());
            } catch {
                alert('Camera access is required for QR-Codes scanning and profile pictures.');

                return;
            }
            nextStepCallback(3);
        }
    }

    async askMicrophonePermission(nextStepCallback: (step: number) => void) {
        if (Capacitor.isNativePlatform()) {
            navigator?.mediaDevices
                ?.getUserMedia({ audio: true })
                ?.then(() => nextStepCallback(4))
                .catch(() => {
                    alert('Microphone access is required for the tuner and loudness meter.');
                    return nextStepCallback(4)
                });

        } else {
            try {
                const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
                stream.getTracks().forEach(track => track.stop());
            } catch {
                alert('Microphone access is required for the tuner and loudness meter.');
                return;
            }
            nextStepCallback(4)
        }
    }

    completeSetup() {
        this.permissionsGranted.emit(true);
        this.ref.close();
    }
}
